import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../redux/store'
import Button from '../../components/Button'
import Checkbox from '../Checkbox'
import { FooterType } from '../../types/components'
import {
	FooterWrapper,
	ButtonWrapper,
	// ButtonText,
	TnC,
	ArrowImg,
} from './style'
import { updateView } from '../../redux/slices/meta'
import { ViewTypes } from '../../types/state'
import arrowLogo from '../../asset/arrow.png'

const Footer = ({ onSubmit, voteSelected, isLoading }: FooterType) => {
	const dispatch = useDispatch()
	const [tncChecked, setTncChecked] = useState(false)
	const metaData = useSelector((state: RootState) => state.meta)
	const translations = useSelector(
		(state: RootState) => state.translations.data
	)

	const toggleWindowPortal = () => {
		dispatch(updateView(ViewTypes.TNC))
	}

	const onTncCheck = () => {
		if (tncChecked) {
			setTncChecked(false)
		} else {
			setTncChecked(true)
		}
	}

	return (
		<FooterWrapper>
			<Checkbox checked={tncChecked} onClick={() => onTncCheck()}>
				{translations.AGREE}
				<span
					role="presentation"
					onClick={toggleWindowPortal}
					// onKeyDown={() => showModal()}
				>
					<TnC>{translations.TNC}</TnC>
				</span>
			</Checkbox>
			<ButtonWrapper device={metaData.deviceType}>
				<Button
					isLoading={isLoading}
					onBtnClick={onSubmit}
					isEnabled={tncChecked && voteSelected}
					width="180px"
				>
					<span>
						{translations.LOCK_OPTION} <ArrowImg src={arrowLogo} />
					</span>

					{/* <ButtonText>{translations.SUBMIT_VOTE}</ButtonText> */}
				</Button>
			</ButtonWrapper>
		</FooterWrapper>
	)
}

export default Footer
